
export default {
    name: 'caisse-info',
    components: {},
    props: {
        op_info: Object
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {
        console.log("info cais");
        
        // if (this.has_two_currencies) {
        //     console.log("fetch info curr");
            
        //     this.currency_info = this.$store.getters['info_currency']
        // }
    },

    methods: {

    }
}
